import React from 'react';
import {Button, Grid, Typography} from "material-ui";
import Cropper from 'react-cropper';

export default class ImageCropper extends React.Component {
    render() {

        const {
            ratioWidth,
            ratioHeight,
            imageToCrop,
            cropResult,
            index,
            autoCropArea,
            cropBoxResizable
        } = this.props;

        const divImages = {
            border: '1px solid #ddd',
            height: 300,
            width: '100%',
            padding: 5
        };

        const imgPreview = {
            height: '100%',
            width: '100%',
            overflow: 'hidden',
            display: 'block',
            margin: 'auto',
            border: '1px solid rgb(221, 221, 221)'
        };

        const imgCropped = {
            height: '100%',
            display: 'block',
            margin: 'auto',
            border: '1px solid rgb(221, 221, 221)'
        };

        return (
            <Grid container spacing={24}>
                <Grid item xs={12}>
                    <Cropper
                        style={{height: 400, width: '100%' }}
                        aspectRatio={ratioWidth / ratioHeight}
                        autoCropArea={autoCropArea}
                        viewMode={2}
                        dragMode="move"
                        preview={'.img-preview-' + index}
                        cropBoxResizable={cropBoxResizable}
                        guides={false}
                        zoomable={false}
                        src={imageToCrop.preview}
                        ref='cropper'
                    />
                </Grid>
                <Grid container spacing={24}>
                    <Grid item xs={12}>
                        <Button
                            variant="raised"
                            color="primary"
                            style={{float: 'right'}}
                            onClick={() => {
                                if (typeof this.refs.cropper.getCroppedCanvas() === 'undefined') {
                                    return;
                                }
                                this.props.setCropResult(
                                    this.refs.cropper.getCroppedCanvas().toDataURL()
                                );
                        }}>
                            Crop Image
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={24}>
                        <Grid item xs={6}>
                            <Typography variant="body2" gutterBottom>
                                Preview
                            </Typography>
                            <Grid item xs={12} style={divImages}>
                                <div className={'img-preview-' + index} style={imgPreview} />
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body2" gutterBottom>
                                Cropped
                            </Typography>
                            <Grid item xs={12} style={divImages}>
                                {cropResult && <img style={imgCropped} src={cropResult} alt="Cropped" />}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/image/cropper.js